import { useGlobal } from '@/utils/useGlobal';
import BackToTop from '@elem/compCommon/BackToTop';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import FreeQuote from './components/FreeQuote';
import J from './components/J';
import K from './components/K';
import L from './components/L'; // 暂未获得授权，临时取消上线
import M from './components/M';
import N from './components/N';
import Preparing from './components/Preparing';
import { PAGE_LINK } from './components/Preparing/data';
import R from './components/R';

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('powerbackup');
    const obj: SideMenuProps = {
        items: [
            { text: t('secD_btn1'), link: PAGE_LINK.E },
            { text: t('secD_btn2'), link: PAGE_LINK.F },
            { text: t('secD_btn3'), link: PAGE_LINK.G },
            ...(locale === 'us' ? [{ text: t('secD_btn4'), link: PAGE_LINK.H }] : []),
        ],
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean) => {
        setShoppingCarts(carts);
        if (isClose) {
            setVisible(false);
        }
    };

    const handleAddCart = (card: ShopifyCartItemType, listName = 'none') => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: card.title,
            list_name: listName,
            price: card?.discountPrice,
            tag: 'none',
            quantity: shoppingCarts.length + 1,
            button_name: t('common_card_buy'),
        });
        const obj: ShopifyCartItemType = { ...card };
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
        if (target) {
            obj.quantity = target.quantity + (target?.quantity < target.inventory ? 1 : 0);
            // setShoppingCarts([
            //     obj,
            //     ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            // ]);
            EcoDesignEventsBus.emit('eco-cart-add', [
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            //setShoppingCarts([obj, ...shoppingCarts]);
            EcoDesignEventsBus.emit('eco-cart-add', [obj, ...shoppingCarts]);
        }
        setVisible(true);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            {['us'].includes(locale as string) && isClient && createPortal(<FreeQuote />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
            <B />
            <C />
            <Preparing obj={obj} handleAddCart={handleAddCart} />
            <EmailSubscribe locale={locale} className="email-subscribe" pageType={PAGE_TYPE.BatteryBackupForHome} entry_position={6} />
            <J />
            <K />
            <L />
            <M />
            <N />
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
            {locale === 'us' && <R />}
        </>
    );
}
